export function getResizedPhoto(photo) {

  let blockWidth      = photo.gandr_size.width;
    let blockHeight     = photo.gandr_size.height;
    let photoWidth      = photo.width;
    let photoHeight     = photo.height;
    let blockRatio      = blockHeight / blockWidth;
    let photoRatio      = photoHeight / photoWidth;
    let isPhotoPortrait = photoHeight > photoWidth;
    let isBlockPortrait = blockHeight > blockWidth;
    
    let portraitMultiplier = photoWidth / photoHeight;
    let landscapeMultiplier  = photoHeight / photoWidth;
    
    // are both sides smaller than the block's size? then scale up - biggest size first
    if ( photoWidth < blockWidth && photoHeight < blockHeight ) {
      if ( isPhotoPortrait ) {
        photoHeight = blockHeight;
        photoWidth = portraitMultiplier * blockHeight;
      }
      else {
        photoWidth = blockWidth;
        photoHeight = landscapeMultiplier * blockWidth;
      }
    }
    
    // Now lets make max width of the both 100% on both edges (no overflow)
    if ( photoWidth > blockWidth ) {
      photoWidth = blockWidth;
      photoHeight = landscapeMultiplier * blockWidth;
    }
    
    if ( photoHeight > blockHeight ) {
      photoHeight = blockHeight;
      photoWidth = portraitMultiplier * blockHeight;
    }
    
    
    // Figure out how much to scale the photo to fill any white space
    let scale = 1;
    if ( blockRatio > photoRatio ) {
      scale = blockRatio / photoRatio;
    }
    else {
      scale = photoRatio / blockRatio;
    }
    
    // Calculate what the width & height of the photo will be after scaling
    let renderedWidth   = Math.floor(photoWidth * scale);
    let renderedHeight  = Math.floor(photoHeight * scale);
    let initialPosition;
    
    // Now get how much of the photo will overflow outside the frame so we can calculate the middle
    if ( renderedWidth > photo.gandr_size.width ) {
      initialPosition = {
        x: (((renderedWidth - photoWidth) / 2) * -1),
        y: 0
      }
    }
    else {
      initialPosition = {
        x: 0,
        y: (((renderedHeight - photoHeight) / 2) * -1)
      }
    }
    
    photo.renderedWidth = renderedWidth;
    photo.renderedHeight = renderedHeight;
    photo.width = photoWidth;
    photo.height = photoHeight;
    photo.scale = scale;
    photo.initial_position = initialPosition;
  
    return photo;


}